import moment from "moment";
import { isDateClosedOutForRoom } from "../../modules/isDateClosedOutForRoom";
import { getMaxStayForDate } from "../../../../../utils/getMaxStayForDate";

export const MaxStayManagement = (props) => {
  const {
    dateColumns,
    currentMonth,
    selectedYear,
    maximumStay,
    handleCellClick,
    ratePlanId,
    roomId,
    closeout,
  } = props;
  return (
    <tr>
      <td className="sticky-column weekend-highlight">
        <strong>Max Stay</strong>
      </td>
      {dateColumns.map((date) => {
        const day = moment(date, "DD MMM").date();
        const dateKey = moment(
          `${day}-${currentMonth.month() + 1}-${selectedYear}`,
          "DD-MM-YYYY"
        ).format("DD-MM-YYYY");
        const maxStayArray = maximumStay[roomId]?.[dateKey] || [];
        const maxStayForDate = getMaxStayForDate({
          maximumStays: maxStayArray,
          selectedRatePlanId: ratePlanId,
        });
        return (
          <td
            key={`${roomId}-${date}-maximumstay`}
            className="availability-cell"
            onClick={() =>
              handleCellClick(roomId, dateKey, ratePlanId, "maximumStay")
            }
            style={{
              cursor: "pointer",
              backgroundColor: isDateClosedOutForRoom(roomId, dateKey, closeout)
                ? "#f4e736"
                : "transparent",
            }}
          >
            <div>{maxStayForDate || "N/A"}</div>
          </td>
        );
      })}
    </tr>
  );
};
